import { render } from "./viewHeader.vue?vue&type=template&id=64f78059"
import script from "./viewHeader.vue?vue&type=script&lang=js"
export * from "./viewHeader.vue?vue&type=script&lang=js"

import "./viewHeader.vue?vue&type=style&index=0&id=64f78059&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__